import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const muiStyles = (theme: ApplicationMuiTheme) => ({
    root: {
        fontSize: '13px',
        paddingBottom: '20px'
    },
    mainTextContainer: { paddingBottom: '25px' },
    midSizeLine: { fontSize: '20px' },
    clientName: { fontSize: '29px' },
    boldText: { fontWeight: 'bold' as const },
    buttonStyle: {
        width: '142px',
        fontSize: '13px',
        height: '40px',
        borderRadius: '5px'
    },
    paddingText: { paddingTop: '8.625px' }
});